import React, { useState } from 'react';
import { FileUpload } from '../components/FileUpload';
import { FileManager } from '../components/FileManager';
import { FileUploadDebugger } from '../components/FileUploadDebugger';

export const Files: React.FC = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  return (
    <div className="space-y-6">
      <FileUploadDebugger />
      <FileUpload
        onUploadComplete={() => setRefreshTrigger(prev => prev + 1)}
        onNarrative={(message, type) => console.log(message, type)}
      />
      <FileManager
        refreshTrigger={refreshTrigger}
        onNarrative={(message, type) => console.log(message, type)}
      />
    </div>
  );
};